import { data } from '../../svg/Lock/data';
import { makeIcon } from '../makeIcon';

export const Lock = makeIcon(data, 'lock', 'Lock');

export default Lock;
